<template>
  <section class="sac-step sac-step--1" v-if="model.etapaAtiva == 1">
    <div class="wrapper">
      <form class="form form-grid" @submit.stop.prevent="proximaEtapa" ref="formEtapa1" novalidate>
        <div v-for="(prd,i) in model.produtos" class="sac-product-data col--wide">
          <button v-if="model.produtos.length > 1" type="button" class="btn-delete" @click.stop.prevent="removerProduto(i)">
            <span class="btn-delete__icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.75 8.75C10.3023 8.75 10.75 9.19772 10.75 9.75V15.75C10.75 16.3023 10.3023 16.75 9.75 16.75C9.19772 16.75 8.75 16.3023 8.75 15.75V9.75C8.75 9.19772 9.19772 8.75 9.75 8.75Z" fill="#F5F5F5"/>
                <path d="M14.25 8.75C14.8023 8.75 15.25 9.19772 15.25 9.75V15.75C15.25 16.3023 14.8023 16.75 14.25 16.75C13.6977 16.75 13.25 16.3023 13.25 15.75V9.75C13.25 9.19772 13.6977 8.75 14.25 8.75Z" fill="#F5F5F5"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.25 1.25C14.913 1.25 15.5487 1.51358 16.0176 1.98242C16.4864 2.45126 16.75 3.08696 16.75 3.75V4.25H20.25C20.8023 4.25 21.25 4.69772 21.25 5.25C21.25 5.80228 20.8023 6.25 20.25 6.25H19.75V19.5C19.75 19.9641 19.5655 20.4091 19.2373 20.7373C18.9091 21.0655 18.4641 21.25 18 21.25H6C5.53587 21.25 5.09089 21.0655 4.7627 20.7373C4.43451 20.4091 4.25 19.9641 4.25 19.5V6.25H3.75C3.19772 6.25 2.75 5.80228 2.75 5.25C2.75 4.69772 3.19772 4.25 3.75 4.25H7.25V3.75C7.25 3.08696 7.51358 2.45126 7.98242 1.98242C8.45126 1.51358 9.08696 1.25 9.75 1.25H14.25ZM6.25 19.25H17.75V6.25H6.25V19.25ZM9.75 3.25C9.61739 3.25 9.49025 3.30272 9.39648 3.39648C9.30272 3.49025 9.25 3.61739 9.25 3.75V4.25H14.75V3.75C14.75 3.61739 14.6973 3.49025 14.6035 3.39648C14.5331 3.32608 14.4439 3.27894 14.3477 3.25977L14.25 3.25H9.75Z" fill="#F5F5F5"/></svg>
            </span>
          </button>
          <ProductForm v-model="model.produtos[i]" :index="i" />
        </div>

        <div class="col--wide">
          <button type="button" class="btn btn--wide btn--add" @click.stop.prevent="handleAddProduct">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2.5C12.6904 2.5 13.25 3.05964 13.25 3.75V10.75H20.25C20.9404 10.75 21.5 11.3096 21.5 12C21.5 12.6904 20.9404 13.25 20.25 13.25H13.25V20.25C13.25 20.9404 12.6904 21.5 12 21.5C11.3096 21.5 10.75 20.9404 10.75 20.25V13.25H3.75C3.05964 13.25 2.5 12.6904 2.5 12C2.5 11.3096 3.05964 10.75 3.75 10.75H10.75V3.75C10.75 3.05964 11.3096 2.5 12 2.5Z" fill="currentColor"/></svg>
            <span class="btn__label">{{ _e('sac_novo_produto') }}</span>
          </button>
        </div>

        <div class="sac-separator col--wide"></div>

        <div class="sac-actions" v-if="model.produtos.length > 0">
          <button type="submit" class="btn btn--primary">
            <span class="btn__label">{{ _e('sac_proximo') }}</span>
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.186 5.91847L13.0251 4.53979C13.7417 5.70944 14.4435 6.73839 15.1304 7.62663C15.8322 8.50005 16.5491 9.2846 17.2809 9.98026C18.0128 10.6759 18.7969 11.3271 19.6335 11.9339L19.6334 12.0672C18.7961 12.6602 18.011 13.305 17.2783 14.0016C16.5455 14.6982 15.8276 15.4911 15.1246 16.3803C14.4366 17.2546 13.7335 18.2845 13.0154 19.4699L11.178 18.0714C11.7914 17.1378 12.4196 16.3006 13.0628 15.5596C13.7059 14.8186 14.3489 14.1813 14.9919 13.6476C15.6349 13.0992 16.2629 12.6618 16.8758 12.3356C17.4888 11.9945 18.0718 11.7571 18.6249 11.6235L18.6244 12.3789C18.0715 12.2459 17.4888 12.0093 16.8763 11.669C16.2638 11.3288 15.6364 10.8923 14.9941 10.3595C14.3518 9.81185 13.7096 9.17537 13.0674 8.45002C12.4253 7.70986 11.7981 6.86602 11.186 5.91847ZM4.70413 10.8105L11.8553 10.8059C12.8716 10.8052 13.7907 10.8416 14.6126 10.9151C15.4495 10.9886 16.2041 11.0844 16.8766 11.2025L18.378 12.0013L16.8755 12.8021C16.2029 12.9063 15.4482 12.9956 14.6112 13.0702C13.7892 13.1448 12.87 13.1825 11.8538 13.1831L4.70258 13.1878L4.70413 10.8105Z" fill="currentColor"></path>
            </svg>
          </button>
        </div>

      </form>

    </div>
  </section>
</template>
<script setup>
import { ref, computed, onMounted } from 'vue';
import { _e } from '../../../helpers/l10n';
import { useSacStore } from '../../../store/SacStore';
import ProductForm from './ProductForm.vue';

const model = useSacStore();

const formEtapa1 = ref();

function handleAddProduct(e) {
  model.adicionaNovoProduto();
}

function removerProduto(index) {
  model.removerProduto(index);
}

function proximaEtapa() {
  if(formEtapa1.value.checkValidity()) {
    formEtapa1.value.classList.remove('form--validated');
    model.irParaEtapa(2);
  } else {
    formEtapa1.value.classList.add('form--validated');
    formEtapa1.value.reportValidity();
  }
}
</script>
